<div mat-dialog-content>
  <p>
    o : vêtement d'occasion attribué à un porteur
  </p>

  <p>
    t : porteur transféré (changement de client/site)
  </p>
</div>
<div class="dialog-buttons">
  <button mat-stroked-button (click)="refuse()">Retour</button>
</div>